import { lazy } from "react";
import { RouteConfig } from "../../types/RouteConfig";

export const helpVideosPageRoute: RouteConfig<'with-page'> = {
    name: 'Video Guides',
    path: '/help/videos',
    icon: 'dripicons-media-play',
    page: lazy(() => import('.')),
    flags: ['member-route']
}